import React from 'react';
import { Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import StatusBadge from '@/components/ui/StatusBadge';

const DAYS_MAP = {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
};

const formatWorkingDays = (days) => {
    if (!Array.isArray(days) || days.length === 0) return '—';
    return days.map((d) => DAYS_MAP[d.toLowerCase()] || d).join(', ');
};

export const getScheduleColumns = ({ openPanel, handleMenuClick, canUpdate, canDelete }) => [
    {
        title: 'Name',
        dataIndex: 'title',
        key: 'title',
        render: (val) => (
            <span style={{ fontWeight: 600, color: 'var(--ant-color-text, #1e293b)' }}>
                {val}
            </span>
        ),
    },
    {
        title: 'Time Range',
        key: 'timeRange',
        render: (_, record) => {
            const format12Hour = (timeStr) => {
                if (!timeStr) return '';
                const d = dayjs(`2000-01-01T${timeStr}`);
                return d.isValid() ? d.format('h:mm A') : timeStr;
            };
            const start12 = format12Hour(record.startTime);
            const end12 = format12Hour(record.endTime);
            const timeRange12 = `${start12} - ${end12}`;
            const timeRange24 = `${record.startTime ?? '—'} - ${record.endTime ?? '—'}`;
            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>{timeRange12}</span>
                    <span style={{ fontSize: '11px', color: '#888' }}>{timeRange24}</span>
                </div>
            );
        },
    },
    {
        title: 'Grace Time',
        dataIndex: 'graceTime',
        key: 'graceTime',
        render: (val) => (val ? `${val} mins` : '0 mins'),
    },
    {
        title: 'Calendar End Day',
        dataIndex: 'calendarEndDay',
        key: 'calendarEndDay',
        width: 140,
        render: (val) => val ?? 1,
    },
    {
        title: 'Working Days',
        dataIndex: 'workingDays',
        key: 'workingDays',
        render: (val) => formatWorkingDays(val),
    },
    {
        title: 'Employees Assigned',
        dataIndex: 'userCount',
        key: 'userCount',
        width: 180,
        render: (val) => val ?? 0,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 120,
        render: (_, record) => <StatusBadge status={record.status} />,
    },
    {
        title: 'Action',
        key: 'action',
        width: 72,
        render: (_, record) => {
            const items = [
                { key: 'view', label: 'View Details' },
                ...(canUpdate ? [{ key: 'edit', label: 'Edit' }] : []),
                ...(canDelete ? [{ key: 'delete', label: 'Delete', danger: true }] : []),
            ];
            return (
                <Dropdown
                    menu={{
                        items,
                        onClick: ({ key, domEvent }) => {
                            domEvent?.stopPropagation();
                            handleMenuClick(key, record);
                        },
                    }}
                    trigger={['click']}
                >
                    <MoreOutlined style={{ cursor: 'pointer', fontSize: 18 }} />
                </Dropdown>
            );
        },
    },
];
